<template>
  <FlotoCrudContainer
    ref="list"
    as-table
    :fetch-fn="fetchDepartmentFn"
    :columns="tableColumns"
    :selectable="selectable"
    v-bind="$attrs"
    @selection-change="$emit('selection-change', $event)"
  >
    <template v-slot:form>
      <span />
    </template>
    <template v-slot="slotData">
      <slot v-bind="slotData"></slot>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import { getDepartmentsApi } from '@state/modules/department'
import { buildRelationalQualificationStructure } from '@data/qualification'

export default {
  name: 'DepartmentList',
  props: {
    fetchFn: { type: Function, default: undefined },
    selectable: { type: Boolean, default: false },
    hiddenColumns: {
      type: Array,
      default() {
        return ['contactNo']
      },
    },
    excludeItemsById: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      searchCriterias: {
        quals: [],
      },
      tableColumns: [
        { name: `${this.$t('name')}`, key: 'name' },
        { name: `${this.$t('description')}`, key: 'description' },
      ],
    }
  },
  methods: {
    fetchDepartmentFn(limit, offset) {
      const quals = []
      if (this.excludeItemsById.length) {
        quals.push(
          buildRelationalQualificationStructure(
            'id',
            'not_in',
            this.excludeItemsById,
            'long',
            'db'
          )
        )
      }
      if (this.fetchFn) {
        return this.fetchFn(limit, offset)
      } else {
        return getDepartmentsApi({ quals })
      }
    },
    refresh() {
      this.$refs.list.refresh()
    },
  },
}
</script>
